// ** Initial State
const initialState = {
  fileUploadInProgress: false,
  fileUploadProgress: 0,
  fileUploadError: null,
  fileUrl: null,
  fileId: null,
  fileName: null
}

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPLOAD_FILE_START':
      return {
        ...state,
        fileUploadInProgress: true,
        fileUploadProgress: 0,
        fileUploadError: null
      }
    case 'UPLOAD_FILE_PROGRESS':
      return {
        ...state,
        fileUploadInProgress: true,
        fileUploadProgress: action.progress
      }
    case 'UPLOAD_FILE_PAUSED':
      return { ...state, fileUploadInProgress: false }
    case 'UPLOAD_FILE_RESUMED':
      return { ...state, fileUploadInProgress: true }
    case 'UPLOAD_FILE_SUCCESS':
      return {
        ...state,
        fileUploadInProgress: false,
        fileUploadProgress: 100,
        fileUrl: action.url,
        fileId: action.fileId,
        fileName: action.fileName ?? null
      }
    case 'UPLOAD_FILE_ERROR':
      return {
        ...state,
        fileUploadInProgress: false,
        fileUploadError: action.error
      }
    case 'CLEAR_UPLOAD_RESULT':
      return {
        ...state,
        fileUrl: null,
        fileId: null,
        fileName: null
      }
    default:
      return state
  }
}

export default AuthReducer
